import React from 'react'
import image from '../../../../assets/homepage_hp6.png'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
const LowerSectionLatestProductLeft = () => {
    const products = [
        {
            "id": 1,
            "name": "Headphone 1",
            "author": "Charles Duhigg",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 2,
            "name": "Headphone 2",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 3,
            "name": "Headphone 3",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 4,
            "name": "Headphone 4",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 5,
            "name": "Headphone 5",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 6,
            "name": "Headphone 6",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
    ]
    const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
    }
    return (
        <>

            <h2 className="title1">Latest Products</h2>
                <Slider {...sliderSettings}>
                {products.map((i,index)=>(
                    <div className="item" key={index}>
                        <div className="pro-bx">
                            <div className="prod-img mt-0 p-0">
                                <img className="img-fluid" src={i.image} alt="" />
                                <a href="#" className="btn-quick">
                                    Quick View
                                </a>
                            </div>
                            <h4>Gaming</h4>
                            <h3>A blender is a kitchen and laboratory appliance</h3>
                            <div className="price-prt2">
                                <h5>
                                    $245.00 <span>$299.00</span>
                                </h5>
                            </div>
                        </div>
                    </div>
                     ))}
                </Slider>
        </>
    )
}

export default LowerSectionLatestProductLeft